angular.module("events")
    .controller("EventMailAccountCtrl", ['event','$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', 'LoginService', 'logService',
        function (event, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, LoginService, logService) {
            logService.debug("EventMailAccountCtrl");
            $scope.isCorrectReplyTo = true;
            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_MAIL_ACCOUNT_WRITE");
            if(!Array.isArray($scope.$parent.menusItems)) {
                $state.go("events.edit", { id: $stateParams.id });
            } else {
                let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
                if(results.length > 0) {
                    $scope.allowWrite &&= results[0].editable;
                } else {
                    $scope.allowWrite = false;
                }
            }
            $scope.event = event;
            $scope.event.mail_list_bcc_array = [];
            $scope.event.mail_list_reply_array = [];

            if ($scope.event.reply_to != null) $scope.event.mail_list_reply_array = $scope.event.reply_to.split(",");
            if ($scope.event.bcc != null) $scope.event.mail_list_bcc_array = $scope.event.bcc.split(",");

            $scope.radio = { value: null };

            $rootScope.breadcrumb = [
            { title: $filter('translate')('events.title'), url: "events.list" },
            { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
            { title: $filter('translate')('events.mail_account.mail_account') }
            ];
            $rootScope.title = $scope.event.name + " - " + $filter('translate')('events.mail_account.mail_account');

            Restangular.all('MailAccounts').getList().then(function (mailsAccounts) {
                $scope.mailsAccounts = mailsAccounts;
            });

            if ($scope.event.mail_account_id != null) {
                if ($scope.event.FK_events_mail_accounts.email === $scope.event.bcc) $scope.radio.value = "from";
                else if ($scope.event.bcc == null || $scope.event.bcc == "") $scope.radio.value = "no_bcc";
                else $scope.radio.value = "other_bcc";
            } else {
                $scope.radio.value = "no_bcc";
            }

            $scope.$watch('radio.value', function (value) {
                switch (value) {
                    case "from":
                        $scope.event.bcc = $scope.event.FK_events_mail_accounts.email;
                        $scope.event.mail_list_bcc_array = [];
                        break;
                    case "no_bcc":
                        $scope.event.bcc = "";
                        $scope.event.mail_list_bcc_array = [];
                        break;
                    case "other_bcc":
                        break;
                }
            });

            $scope.save = function () {
                $scope.event.mail_account_id = $scope.event.FK_events_mail_accounts.id;

                if ($scope.event.mail_list_reply_array.length > 1) {
                    $scope.isCorrectReplyTo = false;
                } else {
                    $scope.isCorrectReplyTo = true;

                    if ($scope.event.mail_list_reply_array != null && $scope.event.mail_list_reply_array.length > 0) { $scope.event.reply_to = $scope.event.mail_list_reply_array.join(",") } else { $scope.event.reply_to = null };
                    if ($scope.event.mail_list_bcc_array != null && $scope.event.mail_list_bcc_array.length > 0) { $scope.event.bcc = $scope.event.mail_list_bcc_array.join(",") } else { $scope.event.bcc = null };
                    $scope.event.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('events.edit_success'));
                        }
                    });
                }

            };
            $scope.changeMailAccount = function (row) {
                Restangular.one('MailAccounts', row).get().then(function (result) {
                    if (result.reply_to != null) {
                        $scope.event.mail_list_reply_array = result.reply_to.split(",");
                    } else {
                        $scope.event.mail_list_reply_array = [];
                    }
                    
                });

            };

        }])

;
